import type {UserCardType, UserPageType} from "~/types/User";
import type {SpecificationType} from "~/types/Specification";
import type { StrapiFileType } from "./Files";
import type { PortfolioCardType } from "./Portfolio";
import type { MessageType } from "./Chat";

export interface TaskType {
    active_response: ResponseCardType | null
    assets: StrapiFileType[] | null
    budget: {
        from: number | null
        to: number | null
    } | null
    createdAt: string
    date: TaskDate
    description: string | null
    documentId: string
    execution_location: ExecutionLocationEnum,
    id: number
    is_public: boolean
    is_secure_payment: boolean,
    locale: string | null
    name: string
    owner: UserPageType
    publishedAt: string
    responses: ResponseCardType[]
    specification: SpecificationType,
    task_status: TaskStateEnum
    updatedAt: string
    location: {
        lat: number,
        lng: number,
        address: string,
    } | null,
    boostUntil: string | null,
    viewersCount: number | null,
    viewsCount: number | null,

    /* computed_state: TaskStateEnum
    specification_name: string
    is_archive: boolean
    compute_allow_response: boolean
    isSavePayment: boolean
     */
}

export interface ResponseCardType {
    customer_unread_messages_count: number
    documentId: string
    id: number
    is_blocked: boolean
    payment_method: PaymentMethodEnum | null
    portfolio: PortfolioCardType | null
    state: ResponseStateEnum
    unread_messages_count: number | null
    user_actions?: {name: string, semantics?: string | null}[] | null
}

export interface ResponseType extends ResponseCardType {
    amount: number | null
    createdAt: string
    customer_fee_percent: number | null
    master_fee_percent: number | null
    messages: MessageType[]
    publishedAt: string
    refund_amount: number
    task: TaskType
    updatedAt: string
    
    payment_state: PaymentStateEnum | null
    timestamp?: number
}

export enum ResponseStateEnum {
    PENDING = 'PENDING',
    SUGGESTED = 'SUGGESTED',
    ACCEPTED = 'ACCEPTED',
    REJECTED = 'REJECTED',
    CANCELLED = 'CANCELLED',
    COMPLETED = 'COMPLETED',
    CALL_OFF = 'CALL_OFF',
    REFUSED = 'REFUSED',
}

export enum PaymentMethodEnum {
    CACHE = 'CACHE',
    CASH = 'CASH',
    SECURE = 'SECURE',
}

export enum PaymentStateEnum {
    PROCESSING = 'PROCESSING',
    SUCCESS = 'SUCCESS',
}

export enum TaskStateEnum {
    ACTIVE = 'ACTIVE',
    SUGGESTED = 'SUGGESTED',
    PENDING = 'PENDING',
    REFUSED = 'REFUSED',
    CALL_OFF = 'CALL_OFF',
    COMPLETED = 'COMPLETED',
    DELETED = 'DELETED',
    /* REVIEW = 'REVIEW',
    APPLIED = 'APPLIED',
    ARCHIVED = 'ARCHIVED', */
}

export enum ExecutionLocationEnum {
    DISTANCE = 'DISTANCE',
    AT_CLIENT = 'AT_CLIENT',
    AT_MASTER = 'AT_MASTER',
}

export enum OrderTimeTypeEnum {
    ON_DATE = 'ON_DATE',
    BEFORE_DATE = 'BEFORE_DATE',
    FLEXIBLE = 'FLEXIBLE',
}

export enum OrderTimeRangeEnum {
    MORNING = 'MORNING',
    MIDDAY = 'MIDDAY',
    AFTERNOON = 'AFTERNOON',
    EVENING = 'EVENING',
}

export enum OrderTimePeriodEnum {
    THIS_WEEK = 'THIS_WEEK',
    NEXT_WEEK = 'NEXT_WEEK',
    WITHIN_TWO_WEEKS = 'WITHIN_TWO_WEEKS',
    RANGE_PERIOD = 'RANGE_PERIOD',
}

export interface TaskDate {
    from: string | null,
    to: string | null,
    order_time_type: OrderTimeTypeEnum | null,
    order_time_range: OrderTimeRangeEnum | null,
    order_time_period: OrderTimePeriodEnum | null
}

export interface TaskForm {
    name: string,
    description: string,
    execution_location: ExecutionLocationEnum,
    date: TaskDate,
    specification: string,
    is_secure_payment: boolean,
    portfolio?: string | null,
    assets?: string[] | StrapiFileType[] | null,
    budget: {
        //from: string | number | null,
        to: string | number,
    },
    location: {
        lat: number,
        lng: number,
        address: string,
    } | null,
    work_location?: 'ON_SITE' | ExecutionLocationEnum.DISTANCE,
    work_location_details?: ExecutionLocationEnum.AT_CLIENT | ExecutionLocationEnum.AT_MASTER,
    isBoosted?: boolean,
}

export const TaskFormDefault: TaskForm = {
    name: '',
    description: '',
    execution_location: ExecutionLocationEnum.DISTANCE,
    date: {
        from: null,
        to: null,
        order_time_type: null,
        order_time_range: null,
        order_time_period: null,
    },
    specification: '',
    is_secure_payment: false,
    portfolio: null,
    assets: null,
    budget: {
        to: 0,
    },
    location: null,
    work_location: ExecutionLocationEnum.DISTANCE,
    isBoosted: false,
}